{
	"home": {
		"title": "Home",
		"content": "Hi, my name is Aritra Mondal. Developer, Designer, Gamer ...",
		"attachments": []
	},
	"projects": {
		"title": "Projects",
		"content": "A list of all my ongoing and finished projects",
		"attachments": [
			{
				"name": "project1.in",
				"type": "code"
			},
			{
				"name": "+11",
				"type": "code"
			}
		]
	},
	"papers": {
		"title": "Blogs & Research papers",
		"content": "A list of all my blogs and research papers",
		"attachments": [
			{
				"name": "paper1.pdf",
				"type": "pdf"
			},
			{
				"name": "+3",
				"type": "pdf"
			}
		]
	},
	"experience": {
		"title": "Experience",
		"content": "I've been working as a SDE for the last 4 years and this is a list of all my professional experience so far.",
		"attachments": []
	},
	"education": {
		"title": "Education",
		"content": "A list of all my educational qualifications",
		"attachments": []
	},
	"skills-achievements": {
		"title": "Skills & Achievements",
		"content": "A list of all my skills and achievements",
		"attachments": []
	},
	"bookshelf": {
		"title": "Bookshelf",
		"content": "Engineering books I recommend and technical blogs I follow",
		"attachments": [
			{
				"name": "reading-list.pdf",
				"type": "pdf"
			},
			{
				"name": "+8",
				"type": "pdf"
			}
		]
	}
}
